<ipm-offer-popup *ngIf="componentType === 'offer'" (upgrade)="claimOffer()" (closed)="closePopup()"></ipm-offer-popup>
<!-- Beat22 Diwali Sale: Pro Annual offer popup (opened from the layout); CTA → address + payment gateway, or the upgrade flow -->
<ipm-diwali-pro-popup *ngIf="componentType === 'diwaliOffer'" [isUpgrade]="hasPaidPlan" (claim)="claimOffer()" (closed)="closePopup()" (compare)="openPlansFromOffer()"></ipm-diwali-pro-popup>
<div *ngIf="isLoadData">
    <!-- Annual Offer Banner -->
    <!-- <div *ngIf="componentType !== 'offer' && isOfferBannerVisible && (activePlanSubscription?.tier === 'tier0' || !currentUserInfo)" class="annual-offer-banner ipm-container">
      <div class="banner-content">
        <span class="banner-icon">🎁</span>
        <span class="banner-text">
        <strong>LIMITED-TIME OFFER:</strong> Get commissioned Premium Annual plan at the special price of ₹999/year. Offer ends June 30.
        </span>
      </div>
    </div> -->
<div *ngIf="componentType !== 'offer' && componentType !== 'diwaliOffer'" class="ipm-container" [class.ipm-container]="!componentType || componentType !== 'setting'">
    <ng-container *ngIf="!componentType">
        <div class="subs-heading-section"
        [class.mb-5]="activePlanSubscription && activePlanSubscription.frequency === 'annual'">
        <ng-container *ngIf="!currentUserInfo||  activePlanSubscription && activePlanSubscription?.tier === 'tier0' else NotFreePlan">
            <h2 class="main-heading">
                Discover more with our subscription plans
            </h2>
            <p class="subs-heading" *ngIf="currentUserInfo">
                Upgrade from basic access to unlock additional features and capabilities with our Premium & Pro Plans,
            </p>
            <p class="subs-heading">
                <ng-container *ngIf="currentUserInfo; else unSubLoggedIn">
                    and enjoy 90% of your sales and unlimited beat uploads.
                </ng-container>
                <ng-template #unSubLoggedIn>
                    Retain up to 90% of your sales revenue by utilizing our Premium and Pro plans.
                </ng-template>
            </p>
        </ng-container>
        <ng-template #NotFreePlan>
            <ng-container *ngIf="activePlanSubscription && activePlanSubscription?.tier === 'tier1' else isProPlanTemplate">
                <h2 class="main-heading">
                    You are a Premium Seller
                </h2>
                <p class="subs-heading">
                    Enjoy 100% of sales, limitless beat uploads, editorial playlist consideration,
                </p>
                <p class="subs-heading">
                    <ng-container *ngIf="activePlanSubscription && activePlanSubscription.expiresOnCycleEnd else notCancelText">
                        and more. Your Premium Plan will expire on {{activePlanSubscription?.nextBillingDueAt
                            | date:'dd MMM yyyy'}}. You will be automatically shifted to Basic plan.
                    </ng-container>
                    <ng-template #notCancelText>
                        and more. You shall be charged on <ng-container *ngIf="activePlanSubscription && activePlanSubscription.frequency === 'monthly' else yearlyView">
                            the {{activePlanSubscription?.nextBillingDueAt
                                | dateFormatter: 'date'}} of every month.
                        </ng-container>
                    </ng-template>
                    <ng-template #yearlyView>
                        {{activePlanSubscription?.nextBillingDueAt
                            | dateFormatter: 'year'}} of every year.
                    </ng-template>
                </p>
            </ng-container>
            <ng-template #isProPlanTemplate>
                <h2 class="main-heading">
                    You are a PRO Seller!
                </h2>
                <p class="subs-heading">
                    Enjoy 100% of sales, limitless beat uploads, editorial playlist consideration,
                </p>
                <p class="subs-heading">
                    <ng-container *ngIf="activePlanSubscription && activePlanSubscription.expiresOnCycleEnd else notCancelText">
                        and more. Your Pro Plan will expire on {{activePlanSubscription?.nextBillingDueAt
                            | date:'dd MMM yyyy'}}. You will be automatically shifted to Basic plan.
                    </ng-container>
                    <ng-template #notCancelText>
                        and more. You shall be charged on <ng-container *ngIf="activePlanSubscription && activePlanSubscription.frequency === 'monthly' else yearlyView">
                            the {{activePlanSubscription?.nextBillingDueAt
                                | dateFormatter: 'date'}} of every month.
                        </ng-container>
                    </ng-template>
                    <ng-template #yearlyView>
                        {{activePlanSubscription?.nextBillingDueAt
                            | dateFormatter: 'year'}} of every year.
                    </ng-template>
                </p>
            </ng-template>
        </ng-template>
        <div class="toggle-button-old-section" *ngIf="(activePlanSubscription && activePlanSubscription?.tier !== 'tier0' && ((activePlanSubscription?.tier !== 'tier2'  && activePlanSubscription.frequency !== 'annual')))">
            <mat-button-toggle-group name="switch-button"  [(ngModel)]="subsToggle" class="ipm-common-toggle-button"  (ngModelChange)="onChangeMonthlyPlan()">
                <mat-button-toggle value="monthly" class="common-btn" >Monthly</mat-button-toggle>
                <mat-button-toggle value="annual" class="common-btn" >
                    Annually
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    </div>
    </ng-container>
    <div class="ipm-subs-plans-section">
        <ng-container *ngIf="!componentType || componentType !== 'setting'">
            <div class="ipm-grid-section"
            [class.ipm-grid-section-1]="componentType === 'popup'"
            [class.ipm-single-plan]="getVisiblePlanCount(visibleSubsList) === 1"
            *ngIf="subsList.length > 0 && (subsList | subsFilter : activePlanSubscription) as visibleSubsList" >
                <ng-container *ngFor="let subsData of visibleSubsList" >
                    <ng-container *ngIf="subsData.planName === 'Without Commission';  else otherSection">
                        <div class="subs-plans-section with-commission-label"
                            *ngIf="subsData.isShowPlan"
                            [style.order]="subsData.order">
                            <div class="plans-details {{subsData.className}}">
                                    <div class="ipm-plan-details-section">
                                        <div class="heading d-flex flex-column align-items-start">
                                            <span class="planName">{{subsData.planName}} </span><br>
                                            <span  class="planName">Price</span>
                                        </div>
                                        <p class="royalties-details ">
                                        Perfect for producers ready to level up. Upload your beats, grow your career, and start earning today.
                                        </p>
                                    </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #otherSection>
                        <div class="subs-plans-section"
                                    *ngIf="subsData.isShowPlan && subsData.planName !== 'Without Commission'"
                                    [style.order]="subsData.order"
                                    [class.ipm-merge-grid-2]="subsData?.tier === 'tier2' && subsData?.isExpandPlan && ((activePlanSubscription?.tier !== 'tier2') || (activePlanSubscription?.tier === 'tier2' && subsData?.sellerCommissionPercent !== activePlanSubscription?.sellerCommissionPercent))  "
                                    [class.ipm-merge-grid-3]="subsData?.tier === 'tier2' && subsData?.isExpandPlan && activePlanSubscription?.tier === 'tier2' &&  subsData?.sellerCommissionPercent === activePlanSubscription?.sellerCommissionPercent"
                                    [class.active]="subsData.isActive"
                                    [class.ipm-diwali-plan]="isDiwaliPro(subsData)"
                                    [class.ipm-tier-basic]="subsData.tier === 'tier0'"
                                    [class.ipm-tier-premium]="subsData.tier === 'tier1'"
                                    [class.ipm-tier-pro]="subsData.tier === 'tier2'"
                                    [class.ipm-no-commission]="!subsData.isCommission"
                                    [class.ipm-beside-expanded]="hasExpandedPlan(visibleSubsList) && !subsData?.isExpandPlan"
                                    [class.show-border-radius-all]="componentType">
                                    <!-- the floating sparkles of the sale countdown on the landing page, behind the content -->
                                    <ipm-diwali-sparkles class="ipm-diwali-sparkles" *ngIf="isDiwaliCard(subsData)"></ipm-diwali-sparkles>
                                    <div [class.expended-plan]="subsData?.isExpandPlan">
                                        <span class="current-plan-badge" *ngIf="subsData.isActive && !componentType">
                                            Current Plan
                                        </span>
                                        <span class="plan-popular-label" *ngIf="subsData.tier === 'tier1' && !subsData.isActive && !subsData.isShowRecommendOption && !componentType">
                                            Most Popular
                                        </span>
                                        <div class="recommend-section"
                                            [class.founder-remainder]="subsData?.isShowFounderOption"
                                            [class.wallet-offer-remainder]="subsToggle === 'annual' && isOfferBannerVisible && !subsData?.isShowFounderOption"
                                            *ngIf="subsData.isShowRecommendOption && !subsData.isActive && !componentType">
                                            <ng-container *ngIf="isOfferBannerVisible && subsToggle === 'annual' && !subsData?.isShowFounderOption; else defaultRecommendText">
                                                <span class="wallet-offer-icon">
                                                    <img src="assets/imgs/wallet.png" alt="Wallet Credits" class="wallet-offer-img" />
                                                </span>
                                                <span class="wallet-offer-text">
                                                    <span class="wallet-offer-title">Upgrade Now & Get ₹500 Free Ad Credits Till 31st Aug</span>
                                                </span>
                                            </ng-container>
                                            <ng-template #defaultRecommendText>
                                                ★ {{ subsData?.isShowFounderOption ? "Founder's Birthday & Holiday Season Offer" : 'Recommended'}}
                                            </ng-template>
                                        </div>
                                        <div class="plans-details {{subsData.className}}"
                                            [class.show-not-recommended-section]="(!subsData.isShowRecommendOption && !subsData?.isShowPaytmOption && !subsData?.isShowBpmOfferSection ) || (subsData?.isShowBpmOfferSection && subsData.isActive)"
                                            [class.founder-offer]="subsData?.isShowFounderOption && subsData?.tier === 'tier2'">
                                            <div class="ipm-plan-details-section">
                                                <div class="heading">
                                                    <span class="planName-section">
                                                        <span class="planName">{{subsData.planName}}</span>
                                                        <span class="annual-discount-badge" *ngIf="subsData.id === '0002' && subsToggle === 'annual' && !subsData.isActive && !isDiwaliPro(subsData)">30% OFF</span>
                                                    </span>
                                                    <div class="toggle-button-section" *ngIf="subsData.id === '0002' && (!activePlanSubscription || (activePlanSubscription &&
                                                        ((activePlanSubscription.id !== subsData.id) ||
                                                        (activePlanSubscription.id === subsData.id && activePlanSubscription?.frequency !== 'annual'))))">
                                                        <mat-button-toggle-group name="switch-button"  [(ngModel)]="subsToggle" class="ipm-common-toggle-button" [class.founder-offer-toggle]="subsData?.isShowFounderOption" (ngModelChange)="onChangeMonthlyPlan()">
                                                            <mat-button-toggle value="monthly" class="common-btn" >Monthly</mat-button-toggle>
                                                            <mat-button-toggle value="annual" class="common-btn" >
                                                                Annually
                                                            </mat-button-toggle>
                                                        </mat-button-toggle-group>
                                                    </div>
                                                </div>
                                                 <div class="coupon-applied-section" [class.show-visibility]="subsData.frequency  !== 'monthly'" *ngIf="subsData?.isIndiaWinsSaleOfferApplied">
                                                    <div class="actual-price" [class.show-visibility-actualAnnualPrice]="subsData?.isIndiaWinsSaleOfferApplied">
                                                            ₹{{subsData?.bpmAcutalPriceAmmount}}/-
                                                        <span class="ipm-line"></span>
                                                    </div>
                                                    <!-- <p class="offer-coupon-section">Offer Price 🎉</p> -->                                       
                                                </div>
                                                <div class="amount-section">
                                                    <!-- Diwali sale: the regular price struck through with its 30% off, then the sale price below it -->
                                                    <span class="ipm-diwali-mrp" *ngIf="isDiwaliPro(subsData)">
                                                        <span class="offer-actual-monthly-price">₹4999/-</span>
                                                        <span class="ipm-diwali-mrp-off">30% OFF</span>
                                                    </span>
                                                    <span class="price">
                                                        <ng-container *ngIf="(activePlanSubscription &&  activePlanSubscription.frequency !== 'monthly' && activePlanSubscription?.tier === 'tier1') &&  activePlanSubscription?.tier === 'tier2' else showActualPrice ">
                                                            {{ activePlanSubscription.price > 0 ? "₹" + (activePlanSubscription.price | getAnnualPricePro : activePlanSubscription?.nextBillingDueAt) + '/-': 'Free'}}
                                                        </ng-container>
                                                        <ng-template #showActualPrice>
                                                            {{ isDiwaliPro(subsData) ? '₹3999/-' : (subsData.price > 0 ? "₹" + subsData.price + '/-': 'Free')}}
                                                        </ng-template>
                                                    </span>
                                                    <span class="ipm-diwali-total-off" *ngIf="isDiwaliPro(subsData)">
                                                        <strong>45% off</strong>
                                                        <span>(includes 15% Diwali Discount)</span>
                                                    </span>
                                                    <span class="offer-actual-monthly-price"
                                                        *ngIf="!isDiwaliPro(subsData) && subsData.id === '0002' && subsData.frequency === 'annual' && getMonthlyPriceForPlan(subsData) > 0">
                                                        ₹{{ getMonthlyPriceForPlan(subsData) * 12 }}/-
                                                    </span>
                                                    <span class="label" *ngIf="subsData.price > 0">
                                                        <ng-container *ngIf="subsData.planName !== 'Basic Plan' &&  subsData.frequency  !== 'monthly' && isCouponApplied else isNotAppliedElse">
                                                            for the first {{ subsToggle === 'monthly'  ?  'month' : 'year'}}
                                                        </ng-container>
                                                        <ng-template #isNotAppliedElse>
                                                            <ng-container *ngIf="activePlanSubscription || subsData.tier !== 'tier1' else notActiveSection">
                                                                billed {{ subsData.frequency === 'monthly'  ?  'monthly' : 'yearly'}}
                                                            </ng-container>
                                                            <ng-template #notActiveSection>
                                                                <ng-container *ngIf="subsData.tier === 'tier1'">
                                                                    billed yearly
                                                                </ng-container>
                                                            </ng-template>
                                                        </ng-template>
                                                    </span>
                                                </div>
                                                <span class="ipm-per-month"><ng-container *ngIf="perMonthPrice(subsData) as perMonth">Just ₹{{ perMonth }}/month, billed annually.</ng-container>&nbsp;</span>
                                                <span class="expired-plan-section" *ngIf="subsData.isActive && activePlanSubscription?.nextBillingDueAt && (subsData.price === 149 || subsData.price === 999)">
                                                    <ng-container *ngIf="subsData.price === 149">
                                                        Monthly plan expiring on {{activePlanSubscription?.nextBillingDueAt | date:'dd MMM yyyy'}}
                                                    </ng-container>
                                                    <ng-container *ngIf="subsData.price === 999">
                                                        Expiring on {{activePlanSubscription?.nextBillingDueAt | date:'dd MMM yyyy'}}
                                                    </ng-container>
                                                </span>
                                                <!-- <p class="days-left-text"
                                                [class.visibility-section]="!currentUserInfo && subsData.tier === 'tier1'  || (subsData.tier == 'tier1' &&  subsData.frequency === 'annual') && (!subsData.isActive)"
                                                *ngIf="subsData.tier !== 'tier0'">Valid till {{validTillPlan}}</p> -->
                                                <span class="offer-section show-cursor" [class.hidden]="subsData.tier === 'tier0'">
                                                    {{subsData.offerText}}
                                                </span>
                                                <p class="royalties-details " *ngIf="subsData?.isShowRoyaltyDetails">
                                                {{subsData?.royaltyDetails}}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="feature-list" [class.ipm-basic-padding-126]="subsData.planName === 'Basic Plan' && !currentUserInfo">
                                            <ng-container  *ngFor="let featureData of subsData.featuresList">
                                                <div class="feature-section">
                                                    <span class="ipm-text" *ngIf="featureData.label !== 'more'" [class.hidden] = "featureData.label === 'space'" style="order: 2">
                                                        {{featureData.label}}
                                                        <ipm-info-icon *ngIf="featureData.infoText"
                                                            [message]="featureData.infoText"
                                                            [iconSize]="'10px'"
                                                            [iconColor]="'#888'">
                                                        </ipm-info-icon>
                                                    </span>
                                                    <span class="img-div-section" *ngIf="featureData.label !== 'more' &&  featureData.label !== 'space'" style="order: 1">
                                                        <img priority src="./assets/imgs/icons/tick-icon.png" alt="tick-image" width="18" height="18" *ngIf="featureData.isFeatureAvailable">
                                                        <span *ngIf="!featureData.isFeatureAvailable"><img priority src="./assets/imgs/icons/disabled-tick.png" alt="tick-image" width="18" height="18"></span>
                                                    </span>
                                                </div>
                                            </ng-container>
                                        </div>
                                        <ng-container *ngIf="(!componentType || componentType === 'popup') && subsData.isShowButton">
                                            <div class="button-section"
                                            *ngIf="subsData.planName !== 'Basic Plan' || !currentUserInfo">
                                                <div class="d-flex flex-column w-100">

                                                    <ng-container *ngIf="!currentUserInfo || (subsData.isShowButton &&  (!activePlanSubscription || (activePlanSubscription && activePlanSubscription?.tier  === 'tier0'))) ">
                                                        <button class="btn action-button"
                                                            [style.background]="subsData.backgroundColor"
                                                            [disabled]="isPurchaseDisabled" [attr.title]="isPurchaseDisabled ? purchaseDisabledMessage : null" (click)="buyPlanAction(subsData)">
                                                                {{ isPurchaseDisabled ? "Coming Soon" : (isDiwaliPro(subsData) ? "🪔 Get 45% Off · Claim Diwali Offer" : "Get Started") }}
                                                        </button>
                                                    </ng-container>
                                                    <ng-container *ngIf="currentUserInfo && activePlanSubscription && activePlanSubscription?.tier  !== 'tier0' && !subsData.isActive && subsData.isShowButton"> 
                                                            <button class="btn action-button"
                                                                [style.background]="subsData.backgroundColor"
                                                                (click)="buyPlanAction(subsData, canUpgradeDirectly(subsData) ? '' : 'contactUs')">
                                                                {{canUpgradeDirectly(subsData) ? "Upgrade" : " Contact us to upgrade"}}
                                                            </button>
                                                    </ng-container>
                                                    <ng-container *ngIf="subsData.isActive && subsData.planName !== 'Basic Plan'">
                                                        <div class="d-flex flex-column w-100">
                                                            <div class="d-flex flex-column w-100">
                                                                <button class="btn action-button ipm-cancel-section"
                                                                    [style.background]="subsData.backgroundColor"
                                                                    *ngIf="subsData.isActive && activePlanSubscription && !activePlanSubscription.expiresOnCycleEnd &&  activePlanSubscription?.tier !== 'tier0' && activePlanSubscription?.frequency === subsToggle"
                                                                    (click)="openCancelSubscriptionPop(subsData)">
                                                                    Cancel mandate
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div *ngIf="subsData.tier === 'tier2' && subsData.isExpandPlan" class="ipm-premium-plan-details">
                                        <div class="ipm-details-section">
                                            <div class="ipm-icon-section">
                                                <img priority src="./assets/imgs/subs-pro-icons/1.png" alt="beat-placement">
                                            </div>
                                            <h4 class="ipm-heading">Beat Placement Service</h4>
                                            <p class="ipm-details">
                                                <ng-container *ngIf="activePlanSubscription && activePlanSubscription?.tier === 'tier1'; else proPlanTemplate">
                                                    Get a chance to collaborate with
                                                <span class="ipm-green-text">top artists</span> through our beat placements.
                                                </ng-container>
                                                <ng-template #proPlanTemplate>
                                                    We shall keep you posted about the <span class="ipm-green-text">opportunities</span> through emails.
                                                </ng-template>
                                            </p>
                                        </div>
                                        <div class="ipm-details-section">
                                            <div class="ipm-icon-section">
                                                <div class="golden-icon-wrapper" style="--credit-icon-mask: url('./assets/imgs/subs-pro-icons/credit-pro.png')">
                                                    <img priority src="./assets/imgs/subs-pro-icons/credit-pro.png" alt="beat-placement">
                                                </div>
                                            </div>
                                            <h4 class="ipm-heading kits22">KITS22</h4>
                                            <p class="ipm-details">
                                                {{ activePlanSubscription?.tier === 'tier2' ? 'Access' : 'Get' }} free sound kits from <span class="ipm-green-text">top musicians</span>.
                                            </p>
                                        </div>
                                        <div class="ipm-details-section">
                                            <div class="ipm-icon-section">
                                                <img priority src="./assets/imgs/subs-pro-icons/2.png" alt="beat-placement">
                                            </div>
                                            <h4 class="ipm-heading">Abandoned Cart</h4>
                                            <p class="ipm-details">
                                                Access emails of users with your <span class="ipm-green-text">beats in their cart</span>  and convert them.
                                            </p>
                                        </div>
                                    
                                        
                                        <div class="ipm-details-section">
                                            <div class="ipm-icon-section">
                                                <img priority src="./assets/imgs/subs_pro_tick_img.png" alt="beat-placement">
                                            </div>
                                            <h4 class="ipm-heading">Beat22 Gold Verification</h4>
                                            <p class="ipm-details">
                                                {{ activePlanSubscription?.tier === 'tier2' ? 'You hold the' : 'Become a' }} <span class="ipm-green-text">top-tier partner</span> {{ activePlanSubscription?.tier === 'tier2' ? "seller status with Beat22 Gold." : "seller with Beat22 Gold status." }}</p>
                                        </div>
                                        <ng-container *ngIf="subsData.isCommission; else notCommissionTemplate">
                                            <div class="ipm-details-section">
                                                <div class="ipm-icon-section">
                                                    <img priority src="./assets/imgs/subs-pro-icons/3.png" alt="beat-placement">
                                                </div>
                                                <h4 class="ipm-heading">Priority Access</h4>
                                                <p class="ipm-details"><span class="ipm-green-text">{{ activePlanSubscription?.tier === 'tier2' ? 'You have gained' : 'Gain' }} priority </span> access to platform's new features.</p>
                                            </div>
                                        </ng-container>
                                        <ng-template #notCommissionTemplate>
                                            <div class="ipm-details-section">
                                                <div class="ipm-icon-section">
                                                    <img priority src="./assets/imgs/subs-pro-icons/rupee-icon-transparent.png" alt="beat-placement">
                                                </div>
                                                <h4 class="ipm-heading">0% Commission</h4>
                                                <ng-container *ngIf="subsData.isActive; else notActiveTemplate">
                                                    <p class="ipm-details"><span class="ipm-green-text">You are keeping 100% </span> of your earnings with this plan.</p>
                                                </ng-container>
                                                <ng-template #notActiveTemplate>
                                                    <p class="ipm-details"><span class="ipm-green-text">Take away home 100% </span> of your earnings.</p>
                                                </ng-template>
                                            </div>
                                        </ng-template>
                                    </div>
                        </div>
                    </ng-template>
                </ng-container>
            </div>
        </ng-container>
        <ng-container *ngIf="componentType === 'setting'">
            <div class="subs-plans-section active-setting" [class.mb-4]="activePlanSubscription && activePlanSubscription.tier === 'tier0'">
                <div>
                    <div class="plans-details show-not-recommended-section {{activePlanSubscription.className}}">
                        <div class="heading">
                            {{activePlanSubscription.planName}}
                        </div>
                        <div class="amount-section" >
                            <span class="price">
                                <ng-container *ngIf="(activePlanSubscription &&  activePlanSubscription.frequency !== 'monthly' && activePlanSubscription?.tier === 'tier1') &&  activePlanSubscription?.tier === 'tier2' else showActualPrice ">
                                    {{ activePlanSubscription.price > 0 ? "₹" + (activePlanSubscription.price | getAnnualPricePro : activePlanSubscription?.nextBillingDueAt) + '/-': 'Free'}}
                                </ng-container>
                                <ng-template #showActualPrice>
                                    <ng-container *ngIf="isCouponApplied && activePlanSubscription?.tier === 'tier2' else nonAppliedCoupon">
                                        {{ activePlanSubscription.discountAmount > 0 ? "₹" + activePlanSubscription.discountAmount + '/-': 'Free'}}
                                    </ng-container>
                                    <ng-template #nonAppliedCoupon>
                                        {{ activePlanSubscription.price > 0 ? "₹" + activePlanSubscription.price + '/-': 'Free'}}
                                    </ng-template>
                                </ng-template>
                            </span>
                            <span class="label" *ngIf="activePlanSubscription.price > 0">
                                <ng-container *ngIf="activePlanSubscription.planName === 'Pro Plan' && isCouponApplied else isNotAppliedElse">
                                    for the first {{ subsToggle === 'monthly'  ?  'month' : 'year'}}
                                </ng-container>
                                <ng-template #isNotAppliedElse>
                                    per {{ subsToggle === 'monthly'  ?  'month' : 'year'}}
                                </ng-template>
                            </span>
                        </div>
                        <span class="offer-section show-cursor" [class.hidden]="!activePlanSubscription.offerText" (click)="subsToggle='annual';onChangeMonthlyPlan()">
                            {{activePlanSubscription.offerText}}
                        </span>
                        <p class="royalties-details " *ngIf="activePlanSubscription?.isShowRoyaltyDetails">
                        {{activePlanSubscription?.royaltyDetails}}
                        </p>
                    </div>
                    <div class="feature-list">
                        <ng-container  *ngFor="let featureData of activePlanSubscription.featuresList">
                            <div class="feature-section">
                                <span class="ipm-text" *ngIf="featureData.label !== 'more';" [class.hidden] = "featureData.label === 'space'" style="order: 2;"> {{featureData.label}}</span>
                                <span class="img-div-section" *ngIf="featureData.label !== 'more' &&  featureData.label !== 'space'">
                                    <img priority src="./assets/imgs/icons/tick-icon.png" alt="tick-image" width="18" height="18" *ngIf="featureData.isFeatureAvailable" style="order: 1;">
                                    <span *ngIf="!featureData.isFeatureAvailable"><img priority src="./assets/imgs/icons/disabled-tick.png" alt="tick-image" width="18" height="18"></span>
                                </span>
                            </div>
                        </ng-container>
                    </div>
                    <div class="button-section">
                        <div class="d-flex flex-column w-100">
                            <button class="btn action-button" (click)="exploreSubsPlan()">
                                Explore Plans
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Dynamic KITS22 Container -->
            <div class="pro-annual-container-wrapper" *ngIf="activePlanSubscription && activePlanSubscription.tier !== 'tier0'">
                <div class="pro-annual-custom-container {{ activePlanSubscription.className }}">
                    <!-- Left Wing -->
                    <img src="./assets/imgs/icons/pro-wings.svg" alt="wing-left"
                        class="wing-decoration wing-left">

                    <!-- Center Content -->
                    <div class="pro-annual-content">
                        <!-- Loading State -->
                        <ng-container *ngIf="kits22Data.isLoading">
                            <p-skeleton width="200px" height="24px"></p-skeleton>
                            <p-skeleton width="150px" height="16px"></p-skeleton>
                            <p-skeleton width="100%" height="60px"></p-skeleton>
                        </ng-container>

                        <!-- Loaded Content -->
                        <ng-container *ngIf="!kits22Data.isLoading">
                            <!-- Header with KITS22 -->
                            <div class="pro-annual-header">
                                <img src="./assets/imgs/icons/kits.svg" alt="kits" class="kits-icon">
                                <span class="kits-text">{{ kits22Data.heading }}</span>
                            </div>

                            <!-- Subheading -->
                            <div class="pro-annual-subtitle">
                                Get free Sound Kits under
                                <img src="./assets/imgs/icons/star.svg" alt="star" class="inline-star-icon">
                                <span class="pro-text">PRO</span> plans
                            </div>

                            <!-- Details (hidden for Basic users) -->
                            <div *ngIf="kits22Data.showDetails" class="pro-annual-details">
                                <!-- Quota -->
                                <div class="detail-item">
                                    <span class="label">{{ kits22Data.quotaLabel }}</span>
                                    <span class="value">{{ kits22Data.quota }}</span>
                                </div>

                                <!-- Available Credits -->
                                <div class="detail-item">
                                    <span class="label">Available Credits:</span>
                                    <span class="value">{{ kits22Data.availableCredits }} Credits</span>
                                </div>

                                <!-- Renewal Cycle -->
                                <div class="detail-item">
                                    <span class="label">Renews:</span>
                                    <span class="value">{{ kits22Data.renewalCycle }}</span>
                                </div>
                            </div>

                            <!-- Action Button (hidden for PRO Annual users) -->
                            <button *ngIf="kits22Data.showButton" class="pro-annual-action-btn"
                                (click)="exploreSubsPlan()">
                                <span>Upgrade to </span>
                                <img src="./assets/imgs/icons/star.svg" alt="star" class="btn-icon">
                                <span>PRO</span>
                                <i class="pi pi-arrow-right"></i>
                            </button>
                        </ng-container>
                    </div>

                    <!-- Right Wing -->
                    <img src="./assets/imgs/icons/pro-wings-r.svg" alt="wing-right"
                        class="wing-decoration wing-right">
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="!componentType">
            <ng-container class="subscription-container">
            <div class="reach-section pt-0" #statsSection>
                <div class="heading">
                    BUILT FOR MUSICIANS
                </div>

                <div class="numbers">

                    <div *ngFor="let stat of animatedStats" class="items">
                        <h1>{{stat.displayValue}} </h1>
                        <p>{{stat.text}}</p>
                    </div>
                </div>
            </div>
            <div class="ipm-container">
                <div class="features-section py-3  my-3">
                <div class="heading">
                    <div class="main-heading">For Music Producers and Sound Kits Creators</div>
                    <div class="sub-heading">Powerful tools to sell, manage and grow your music production business — all in one place.</div>
                </div>
                <div class="feature pt-5 mb-0 pb-0" *ngFor="let feature of features;let i = index">
                    <div *ngIf="(i%2==1) ; else elseBlock" >
                        <div class="right">
                            <h2>{{feature.heading.title}}</h2>
                            <p>{{feature.heading.subtitle}}</p>
                        </div>
                        <div class="separator odd"></div>
                        <div class="btns-img odd ">
                            <div class="img-gradient"  [ngClass]="'gradient-' + activeGradients[i]" >
                                <div class="img-container">
                                    <!-- Previous image sliding out -->
                                    <div class="img-wrapper img-previous" *ngIf="animatingFeatures[i]"
                                        [class.slide-out-to-left]="slideDirections[i] === 'left'"
                                        [class.slide-out-to-right]="slideDirections[i] === 'right'">
                                        <img [src]="feature.buttons[previousButtons[i]].imageUrl" alt="previous image">
                                    </div>
                                    <!-- Current image sliding in or static -->
                                    <div class="img-wrapper img-current"
                                        [class.slide-in-from-right]="slideDirections[i] === 'left' && animatingFeatures[i]"
                                        [class.slide-in-from-left]="slideDirections[i] === 'right' && animatingFeatures[i]">
                                        <img [src]="feature.buttons[activeButtons[i]].imageUrl" alt="current image">
                                    </div>
                                </div>
                            </div>
                            <div class="btns">
                                <button *ngFor="let button of feature.buttons ; let j = index" class="btn"
                                [class.active] = "activeButtons[i] === j "
                                (click)="handleBtnClick(i,j, j+1)">
                                    <img class="btn-icon" [src]="button.iconUrl" [alt]="'btn-icon'">
                                    <div class="btn-text">
                                        <div>{{button.title}}</div>
                                        <p>{{button.subtitle}} </p>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                    <ng-template #elseBlock>
                        <h2>{{feature.heading.title}}</h2>
                        <p>{{feature.heading.subtitle}}</p>
                        <div class="separator"></div>
                        <div class="btns-img">
                            <div class="btns">
                                <button *ngFor="let button of feature.buttons ; let j = index" class="btn"
                                [class.active]="activeButtons[i] === j"
                                (click)="handleBtnClick( i,j ,j+1)">
                                    <img class="btn-icon" [src]="button.iconUrl" [alt]="'btn-icon'">
                                    <div class="btn-text">
                                        <div>{{button.title}}</div>
                                        <p>{{button.subtitle}} </p>
                                    </div>
                                </button>
                            </div>
                            <div class="img-gradient" [ngClass]="'gradient-' + activeGradients[i]">
                                <div class="img-container">
                                    <!-- Previous image sliding out -->
                                    <div class="img-wrapper img-previous" *ngIf="animatingFeatures[i]"
                                        [class.slide-out-to-left]="slideDirections[i] === 'left'"
                                        [class.slide-out-to-right]="slideDirections[i] === 'right'">
                                        <img [src]="feature.buttons[previousButtons[i]].imageUrl" alt="previous image">
                                    </div>
                                    <!-- Current image sliding in or static -->
                                    <div class="img-wrapper img-current"
                                        [class.slide-in-from-right]="slideDirections[i] === 'left' && animatingFeatures[i]"
                                        [class.slide-in-from-left]="slideDirections[i] === 'right' && animatingFeatures[i]">
                                        <img [src]="feature.buttons[activeButtons[i]].imageUrl" alt="current image">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
                </div>
            </div>
            </ng-container>

        </ng-container>    
        <ng-container *ngIf="!componentType">
            <!-- Compare Section -->
            <div class="plan-compare-section" *ngIf="subsList.length > 0" id="compare-plan-section">
                <h2 class="main-heading text-center">{{activePlanSubscription && activePlanSubscription?.tier === 'tier2'? "What's in the Pro plan?" : 'Compare all the plans'  }} </h2>
                <p class="subs-heading text-center" *ngIf="activePlanSubscription && activePlanSubscription?.tier !== 'tier2'">
                    {{ activePlanSubscription && activePlanSubscription?.tier === 'tier0' ? 'Basic, Premium and Pro' : 'Pro and Premium'}}
                </p>
                <div class="compare-grid-section set-padding-54"
                    [class.set-grid-col-3]="activePlanSubscription && (activePlanSubscription?.tier === 'tier1')"
                    [class.set-grid-col-2]="activePlanSubscription && activePlanSubscription?.tier === 'tier2'">
                        <div class="plan-section ipm-label-plan-section " >
                            <div class="plan-details hidden">
                                <div class="heading">
                                    Exclusive Plan
                                </div>
                                <div class="amount-section" >
                                    <span class="price">
                                        100/-
                                    </span>
                                    <span class="label inter-400">per month</span>
                                </div>
                                <div class="offer-section">
                                    🎉 Most bought
                                </div>
                                <div class="button-section" >
                                    <button class="btn action-button manrope-700 ">
                                        Get Started
                                    </button>
                                </div>
                            </div>
                            <div class="feature-list">
                                <ng-container  *ngFor="let featureData of compareList[0].compareFeaturesList">
                                    <div class="feature-section">
                                        <span>{{featureData.label}}
                                            <ipm-info-icon *ngIf="featureData.infoText"
                                                [message]="featureData.infoText"
                                                [iconSize]="'10px'"
                                                [iconColor]="'#888'">
                                            </ipm-info-icon>
                                        </span>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <div class="ipm-plan-compare-content">
                            <div class="ipm-plan-compare-grid-section" [class.ipm-has-diwali]="hasDiwaliCompare" #compareScrollContent (scroll)="onCompareGridScroll()">
                             <ng-container *ngFor="let subsData of (compareList | subsFilter : activePlanSubscription : 'compare'); let i = index">
                                <div class="plan-section {{subsData.className}}"
                                    [style.order]="subsData.order ===  -1 ? 0 : subsData.order + 1"
                                    [class.active]="subsData.isActive"
                                    [class.ipm-diwali-compare]="isDiwaliPro(subsData)"
                                    *ngIf="subsData.isShowPlan && subsData.planName !== 'Without Commission'">
                                    <!-- the floating sparkles of the sale countdown on the landing page, behind the content -->
                                    <ipm-diwali-sparkles class="ipm-diwali-sparkles" *ngIf="isDiwaliPro(subsData)"></ipm-diwali-sparkles>
                                    <!-- labels of the plan card on mobile (the table is shown as cards there; hidden on desktop) -->
                                    <span class="current-plan-badge ipm-compare-pill" *ngIf="subsData.isActive">Current Plan</span>
                                    <span class="plan-popular-label ipm-compare-pill" *ngIf="subsData.tier === 'tier1' && !subsData.isActive && !subsData.isShowRecommendOption">Most Popular</span>
                                    <span class="recommend-section ipm-compare-pill" *ngIf="(subsData.isShowRecommendOption || isDiwaliPro(subsData)) && !subsData.isActive">★ Recommended</span>
                                    <div class="plan-details">
                                        <div class="heading">
                                            {{subsData.planName}}
                                        </div>
                                        <div class="amount-section">
                                                <!-- Diwali sale: the regular price struck through with its 30% off, then the sale price -->
                                                <span class="ipm-diwali-mrp" *ngIf="isDiwaliPro(subsData)">
                                                    <span class="offer-actual-monthly-price">₹4999/-</span>
                                                    <span class="ipm-diwali-mrp-off">30% OFF</span>
                                                </span>
                                                <span class="price">
                                                    <ng-container *ngIf="(activePlanSubscription &&  activePlanSubscription.frequency !== 'monthly' && activePlanSubscription?.tier === 'tier1') &&  activePlanSubscription?.tier === 'tier2' else showActualPrice ">
                                                        {{ activePlanSubscription.price > 0 ? "₹" + (activePlanSubscription.price | getAnnualPricePro : activePlanSubscription?.nextBillingDueAt) + '/-': 'Free'}}
                                                    </ng-container>
                                                    <ng-template #showActualPrice>
                                                         {{ isDiwaliPro(subsData) ? '₹3999/-' : (subsData.price > 0 ? "₹" + subsData.price + '/-': '0/-')}}
                                                    </ng-template>
                                                </span>
                                                <span class="label" *ngIf="subsData.price > 0">
                                                    <ng-container *ngIf="subsData.planName !== 'Basic Plan' &&  subsData.frequency  !== 'monthly' && isCouponApplied else isNotAppliedElse">
                                                        for the first {{ subsToggle === 'monthly'  ?  'month' : 'year'}}
                                                    </ng-container>
                                                    <ng-template #isNotAppliedElse>
                                                        <ng-container *ngIf="activePlanSubscription || subsData.tier !== 'tier1' else notActiveSection">
                                                            billed {{ subsData.frequency === 'monthly'  ?  'monthly' : 'yearly'}}
                                                        </ng-container>
                                                        <ng-template #notActiveSection>
                                                            <ng-container *ngIf="subsData.tier === 'tier1'">
                                                                billed yearly
                                                            </ng-container>
                                                        </ng-template>
                                                    </ng-template>
                                                </span>
                                                <span class="ipm-diwali-total-off" *ngIf="isDiwaliPro(subsData)">
                                                    <strong>45% off</strong>
                                                    <span>(includes 15% Diwali Discount)</span>
                                                </span>
                                        </div>
                                        <div class="ipm-per-month"><ng-container *ngIf="perMonthPrice(subsData) as perMonth">Just ₹{{ perMonth }}/month, billed annually.</ng-container>&nbsp;</div>
                                        <div class="offer-section" [class.hidden]="subsData.planName === 'Basic Plan'">
                                           {{subsData.offerText}}
                                        </div>
                                        <div class="button-section"  [class.hidden]="subsData.planName === 'Basic Plan'">
                                             <ng-container *ngIf="!currentUserInfo || (subsData.isShowButton &&  (!activePlanSubscription || (activePlanSubscription && activePlanSubscription?.tier  === 'tier0'))) ">
                                                <button class="btn action-button"
                                                    [style.background]="subsData.backgroundColor"
                                                    [disabled]="isPurchaseDisabled" [attr.title]="isPurchaseDisabled ? purchaseDisabledMessage : null" (click)="buyPlanAction(subsData)">
                                                        {{ isPurchaseDisabled ? "Coming Soon" : (isDiwaliPro(subsData) ? "🪔 Get 45% Off · Claim Diwali Offer" : "Get Started") }}
                                                </button>
                                            </ng-container>
                                            <ng-container *ngIf="currentUserInfo && activePlanSubscription && activePlanSubscription?.tier  !== 'tier0' && !subsData.isActive && subsData.isShowButton"> 
                                                    <button class="btn action-button"
                                                        [style.background]="subsData.backgroundColor"
                                                        (click)="buyPlanAction(subsData, canUpgradeDirectly(subsData) ? '' : 'contactUs')">
                                                        {{canUpgradeDirectly(subsData) ? "Upgrade" : " Contact us to upgrade"}}
                                                    </button>
                                            </ng-container>
                                            <ng-container *ngIf="subsData.isActive && subsData.planName !== 'Basic Plan'">
                                                <div class="d-flex flex-column w-100">
                                                    <div class="d-flex flex-column w-100">
                                                        <button class="btn action-button ipm-cancel-section"
                                                            [style.background]="subsData.backgroundColor"
                                                            *ngIf="subsData.isActive && activePlanSubscription && !activePlanSubscription.expiresOnCycleEnd &&  activePlanSubscription?.tier !== 'tier0' && activePlanSubscription?.frequency === subsToggle"
                                                            (click)="openCancelSubscriptionPop(subsData)">
                                                            Cancel mandate
                                                        </button>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                    <div class="feature-list">
                                        <ng-container  *ngFor="let featureData of subsData.compareFeaturesList">
                                            <div class="feature-section"
                                                [class.ipm-compare-value]="featureData.id === 'feature_001' || featureData.id === 'feature_002' || featureData.id === 'feature_003'"
                                                [class.ipm-compare-verify]="featureData.id === 'feature_0016' && subsData.tier !== 'tier0'">
                                                <span class="mobile-view-label">{{featureData.label}}
                                                    <ipm-info-icon *ngIf="featureData.infoText"
                                                        [message]="featureData.infoText"
                                                        [iconSize]="'10px'"
                                                        [iconColor]="'#888'">
                                                    </ipm-info-icon>
                                                </span>
                                                <span class="ipm-text-center">
                                                    <ng-container *ngIf="featureData.id !== 'feature_001' && featureData.id !== 'feature_003' && featureData.id !== 'feature_002' && featureData.id !== 'feature_0016'">
                                                        <img priority src="./assets/imgs/icons/tick-icon.png" alt="tick-image" width="18" height="18" *ngIf="featureData.isFeatureAvailable">
                                                    </ng-container>
                                                    
                                                    <ng-container *ngIf="subsData.tier === 'tier0'; else notBasicPLan">
                                                        <ng-container *ngIf="featureData.id === 'feature_001'">10</ng-container>
                                                        <ng-container *ngIf="featureData.id === 'feature_002'">2</ng-container>
                                                        <ng-container *ngIf="featureData.id === 'feature_003'">30%</ng-container>
                                                        <span *ngIf="!featureData.isFeatureAvailable && featureData.id !== 'feature_001' && featureData.id !== 'feature_003' && featureData.id !== 'feature_002'">
                                                            <img priority src="./assets/imgs/icons/disabled-tick.png" alt="tick-image" width="18" height="18">
                                                        </span>
                                                    </ng-container>
                                                    <ng-template #notBasicPLan>
                                                            <ng-container *ngIf="featureData.id === 'feature_001'">Unlimited</ng-container>
                                                            <ng-container *ngIf="featureData.id === 'feature_002'">Unlimited</ng-container>
                                                            <ng-container *ngIf="featureData.id === 'feature_003'">{{subsData.sellerCommissionPercent}}%</ng-container>
                                                            <span *ngIf="!featureData.isFeatureAvailable && featureData.id !== 'feature_001' && featureData.id !== 'feature_003' && featureData.id !== 'feature_002' && featureData.id !== 'feature_0016'">
                                                                 <img priority src="./assets/imgs/icons/disabled-tick.png" alt="tick-image" width="18" height="18">
                                                            </span>
                                                            <ng-container *ngIf="subsData.tier === 'tier2' else notProPLan">
                                                                <ng-container *ngIf="featureData.id === 'feature_0016'">
                                                                    <img priority src="./assets/imgs/subs_pro_tick_img.png" alt="golden-tick" class="verification-tick" width="18" height="18">
                                                                </ng-container>
                                                            </ng-container>
                                                        </ng-template>
                                                        <ng-template #notProPLan>
                                                            <ng-container *ngIf="featureData.id === 'feature_0016'">
                                                                <img priority src="./assets/imgs/subs_premium_tick.svg" alt="blue-tick" width="18" class="verification-tick" height="18">
                                                            </ng-container>
                                                    </ng-template> 
                                                </span>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
                            </div>
                            <div class="compare-scrollbar-wrapper" *ngIf="isCompareScrollbarVisible">
                                <input
                                    class="compare-scrollbar"
                                    type="range"
                                    min="0"
                                    [max]="compareScrollMax"
                                    [value]="compareScrollValue"
                                    (input)="onCompareScrollbarInput($event)"
                                    aria-label="Compare plans horizontal scrollbar"
                                />
                            </div>
                        </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
<!-- <ng-container  *ngIf="!componentType">
    <div class="client-section py-3">
        <div class="main-heading pb-5 pb-3 my-3">Client testimonials</div>
        <owl-carousel-o class="review-carousel" [options]="customOptions">
            <ng-container *ngFor="let review of clientReviews">
                <ng-template carouselSlide>
                    <div class="review-card">
                        <div class="review-text">{{review.review}}</div>
                        <div class="userinfo-source">
                            <div class="userinfo">
                                <div class="user-img">
                                    <img [src]="review.user.cover_image" alt="user image">
                                </div>
                                <div class="user-name">
                                    <div>{{review.user.designation}}</div>
                                    <div>{{review.user.userName}}</div>
                                </div>
                            </div>
                            <div class="source">
                                    <img [src]="review.source.source_image" alt="">
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ng-container>
        </owl-carousel-o>
    </div>
</ng-container> -->
<ng-container *ngIf="!componentType">
    <div class="faq-section">
        <div class="ipm-container">
            <div class="main-content">
                <div class="row">
                    <div class="col-md-12 col-lg-6">
                        <span class="fqa-heading-tags">FAQs</span>
                        <h2 class="faq-heading">Frequently Asked Questions</h2>
                        <p class="sub-heading">
                            Beat22 offers music producers subscription plans for monetizing their beats and reaching thousands of daily visiting artists, all at competitive rates.
                        </p>
                    </div>
                    <div class="col-md-12 col-lg-6">
                        <mat-accordion  [className]="'ipm-custom-accordion'" >
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        Will I receive a refund if I choose to upgrade to a higher plan?
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <p>Unfortunately, no refunds are available once you've subscribed to any plan, even if you want to upgrade to a higher one.</p>
                                </mat-expansion-panel>
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Can I change from a monthly to an annual plan within the same subscription?
                                </mat-panel-title>
                                </mat-expansion-panel-header>
                                <p>Yes, you can upgrade from monthly to annual plans. First, cancel your existing monthly subscription mandate,
                                    then immediately upgrade to an annual plan by clicking on "Upgrade to Annual." Please note,
                                    there will be no refund for your current monthly plan.</p>
                            </mat-expansion-panel>
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Is it possible to upgrade from Premium to Pro plans?
                                </mat-panel-title>
                                </mat-expansion-panel-header>
                                <p>
                                    Yes, you can upgrade from Premium to Pro plans. First, cancel your existing monthly subscription mandate, then upgrade to Pro plans by clicking on "Upgrade." Please note, there will be no refund for your current Premium plan.
                                </p>
                            </mat-expansion-panel>
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                <mat-panel-title>
                                    What payment method can I use to subscribe?
                                </mat-panel-title>
                                </mat-expansion-panel-header>
                                <p>
                                    You can subscribe to any plan using UPI and Debit/Credit Cards.
                                </p>
                            </mat-expansion-panel>
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Can I cancel my subscription at any time?
                                </mat-panel-title>
                                </mat-expansion-panel-header>
                                <p>
                                    Yes, you can cancel the subscription at any time. However, please note that you will not be entitled to a refund.
                                </p>
                            </mat-expansion-panel>
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Is there customer support available for questions related to subscriptions?
                                </mat-panel-title>
                                </mat-expansion-panel-header>
                                <p class="line-height">
                                    Yes, you can reach out for subscription-related queries. Email us at <a [href]="commonService.isNewBeatLogoEnable ?  'mailto:support@beat22.com': 'mailto:support@illpeoplemusic.com'" [innerHTML]="commonService.isNewBeatLogoEnable ? 'support@beat22.com' : 'support@illpeoplemusic.com'"></a> or connect with us on
                                    <a href="https://wa.me/919872066692" class="ipm-whatsapp-button" target="_blank"><i class="lab la-whatsapp"></i> WhatsApp</a>
                                </p>
                            </mat-expansion-panel>
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Is there a policy for refunds?
                                </mat-panel-title>
                                </mat-expansion-panel-header>
                                <p>
                                    No, we do not have any refund policy. Unfortunately, once you have subscribed to any plan, you will not receive any refunds.
                                </p>
                            </mat-expansion-panel>
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                <mat-panel-title>
                                    How often will I be billed for my subscription?
                                </mat-panel-title>
                                </mat-expansion-panel-header>
                                <p>
                                    It depends on your subscription plan. If it's monthly, you will be billed once a month. If it's annual, you will be billed once a year.
                                </p>
                            </mat-expansion-panel>
                            </mat-accordion>


                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ipm-footer *ngIf="!componentType"></ipm-footer>
<ng-template #billingAddressesModel let-data>
    <div class="ipm-billing-section">
        <ipm-billing-address-popup [currentPlanData]="data.currentPlanDetails"></ipm-billing-address-popup>
    </div>
</ng-template>


<ng-template #confirmationPop let-data>
    <div class="confirmation-pop">
        <div class="confirmation-pop-body">
            <p class="sub-heading cusPadd">
                <ng-container *ngIf="!data.typeOfConfirmation">
                    Your previous subscription mandate is cancelled. Upgrade to Pro plan?
                </ng-container>
                <ng-container *ngIf="data.typeOfConfirmation">
                    Your payment has been received. Please allow a few minutes for your subscription plan to be updated. Your patience is greatly appreciated.
                </ng-container>
            </p>
            <div class="actions ipm-actions">
                <ng-container *ngIf="!data.typeOfConfirmation">
                    <button color="primary yes-button" class="btn ipm-submit-btn yes-button" type="submit"
                        (click)="closeDialog('yes','purchaseSub', '', data.subscriptionData)">
                        Yes, Continue
                    </button>
                </ng-container>

                <button color="primary" class="btn ipm-submit-btn close-button-primary"
                    [class.close-btn-info]= "data.typeOfConfirmation"
                    type="submit"
                    (click)="closePopup(data.typeOfConfirmation)">
                    {{ data.typeOfConfirmation ? 'Close' : 'No'}}
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #cancelSubscriptionModal let-data>
    <div class="confirmation-pop">
        <div class="confirmation-pop-body">
            <div class="check-section">
                <span class="icon">!</span>
            </div>
            <p class="sub-heading">Are you sure you want to cancel?</p>
            <p class="sub-heading pt-0">
                <span class="sub-message-logout ">Your plan will automatically change to the Basic plan on
                    {{data.activatedSubsObject &&  data.activatedSubsObject?.nextBillingDueAt
                    | date:'dd MMM yyyy'}}.
                </span>
            </p>
            <div class="actions ipm-actions">
                <button class="btn ipm-submit-btn " type="submit"
                    (click)="closeDialog('yes','cancelSub', data.activatedSubsObject)">
                    Yes, Cancel it.
                </button>
                <button  class="btn ipm-submit-btn ipm-cancel-it" type="submit"
                    (click)="closeDialog('cancel','cancelSub')">
                    Don't Cancel
                </button>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #ContactUsSubscriptionModal let-data>
    <div class="confirmation-pop">
        <div class="confirmation-pop-body">
            <div class="ipm-close-icon" (click)="closePopup()">
                <i class="pi pi-times"></i>
            </div>
            <p class="sub-heading">
                Contact us to upgrade to the Pro Annual Plan
            </p>
            <div class="actions ipm-actions flex-column">
                <button class="btn ipm-submit-btn mb-4" type="submit"
                    (click)="closePopup();closeDialog('whatsapp','contactUs', data.activatedSubsObject)">
                    <i class="lab la-whatsapp"></i> WhatsApp
                </button>
                <button  class="btn ipm-submit-btn ipm-cancel-it" type="submit"
                    (click)="closePopup();closeDialog('email','contactUs')">
                    <i class="las la-at"></i>  Email us
                </button>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #upgradeSubscriptionModal let-data>
    <div class="confirmation-pop">
        <div class="confirmation-pop-body">
            <div class="check-section">
                <span class="icon">!</span>
            </div>
            <p class="sub-heading">
                <span *ngIf="data.subscriptionData.planName === data.activatedSubsObject.planName">
                    <ng-container *ngIf="data.activatedSubsObject && data.activatedSubsObject.expiresOnCycleEnd else planIsNotExpired;">
                        Upgrade annual plan after  {{data.activatedSubsObject &&  data.activatedSubsObject?.nextBillingDueAt
                            | date:'dd MMM yyyy'}} or start the annual plan today. If you upgrade now, the current plan's amount won't be adjusted/refunded.
                    </ng-container>
                    <ng-template #planIsNotExpired>
                        To switch from monthly to annual plans, first cancel your current monthly subscription mandate. If you cancel now, the current plan's amount won't be adjusted/refunded. Do you wish to cancel and upgrade?
                    </ng-template>
                </span>
                <span *ngIf="data.subscriptionData.planName !== data.activatedSubsObject.planName">
                    <ng-container *ngIf="activePlanSubscription && !activePlanSubscription.expiresOnCycleEnd else isPlanCancelled">
                        To switch from Premium to Pro plans, first cancel your current subscription mandate. If you cancel now, the current plan's amount won't be adjusted/refunded. Do you wish to cancel and upgrade?
                    </ng-container>
                    <ng-template #isPlanCancelled>
                        If you upgrade to any Pro plans now, the current plan's amount won't be adjusted/refunded. Do you wish to upgrade?
                    </ng-template>
                </span>
            </p>
            <div class="actions ipm-actions">
                <ng-container *ngIf="(data.activatedSubsObject && data.activatedSubsObject.expiresOnCycleEnd) || data.type">
                    <ng-container *ngIf="data.type; else notDataType">
                        <button class="btn ipm-submit-btn " type="submit"
                        (click)="closeDialog(activePlanSubscription.expiresOnCycleEnd ? 'renew' : 'cancelUpdate',data.type, data.activatedSubsObject, data.subscriptionData, data.annualUpgrade)">
                        {{ activePlanSubscription.expiresOnCycleEnd ? 'Upgrade to Pro' : 'Cancel & Upgrade'}}
                    </button>
                    <button  class="btn ipm-submit-btn ipm-cancel-it" type="submit"
                        (click)="closePopup()">
                        <ng-container *ngIf="activePlanSubscription.expiresOnCycleEnd">
                            Later
                        </ng-container>
                        <ng-container *ngIf="!activePlanSubscription.expiresOnCycleEnd">
                            Don't Cancel
                        </ng-container>
                    </button>
                    </ng-container>
                    <ng-template #notDataType>
                        <button class="btn ipm-submit-btn " type="submit"
                        (click)="closeDialog('cancelUpdate',data.type, data.activatedSubsObject, data.subscriptionData, data.annualUpgrade)">
                        Upgrade to annual
                        </button>
                        <button  class="btn ipm-submit-btn ipm-cancel-it" type="submit"
                            (click)="closePopup()">
                            No
                        </button>
                    </ng-template>

                </ng-container>
                <ng-container *ngIf="data.activatedSubsObject && !data.activatedSubsObject.expiresOnCycleEnd &&  !data.type">
                    <button  class="btn ipm-submit-btn" type="submit"
                        (click)="closeDialog('cancelUpdate',data.type, data.activatedSubsObject, data.subscriptionData, data.annualUpgrade)">
                        Cancel & Upgrade
                    </button>
                    <button  class="btn ipm-submit-btn ipm-cancel-it" type="submit"
                        (click)="closePopup()">
                       Don't Cancel
                    </button>
                </ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #loginAlertUserPopup let-data>
	<ipm-non-login-user-popup [isStartSelling]="true"></ipm-non-login-user-popup>
</ng-template>

<ng-template #paymentSuccessPopup let-data>
    <ipm-payment-success [type]="data.popType"
        [message]="'Your payment has been received. Please allow a few minutes for your subscription plan to be updated. Your patience is greatly appreciated.'"
        [isShowButton]="true"
        (isCloseButtonEvent)="closePopup()"
        [buttonText]="data?.buttonText"></ipm-payment-success>
</ng-template>
